exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkText{color:var(--link-primary-color);cursor:pointer;font-weight:bold;text-decoration:underline;margin:0 8px;font-size:0.75rem;font-family:'Lato-Bold', sans-serif}\n", ""]);

// exports
